import React from "react";

import { useState, useEffect } from "react";
import Login from "./Login";
import EMMS from "./EMMS";

import image from "../logos/truroomemms.png";
import "./CommonDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setEmms } from "../redux/slices/emmsSlice";
import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { BrandLoader } from "./TableStatus";

// The EMMS listing table is hidden, not removed. EMMS is expected to be needed
// in more places, so the component stays wired up here behind this flag rather
// than being orphaned -- flip it to true to bring the table back.
const SHOW_EMMS_TABLE = false;




function EmmsDashboard() {


  const [login, setLogin] = useState(false);
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header)
  const oldEmmsData = useSelector((state) => state.emms)
  const [apiloading, setApiLoading] = useState(true);
  const curremmsData = useSelector((state) => state.curremms);
  const curremms = curremmsData.curremms;
  function fetchData() {
    const api = localStorage.getItem("api");
    axios
      .get(api + `/list/emms`, headers)
      .then((response) => {

        dispatch(setEmms(response.data));

        dispatch(setCurrentEmms(response.data[0]));
        const emmsheaders = {
          headers: {
            "Content-Type": "application/json",
            "x-api-id": response.data[0]?.apiId,
            "x-api-key": response.data[0]?.apiKey,
          },
        };
        dispatch(setEmmsHeaders(emmsheaders));

      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        // Also on failure -- otherwise a dead /list/emms leaves the page
        // spinning forever instead of rendering.
        setApiLoading(false);
      });
  }
  React.useEffect(() => {
    fetchData();
  }, []);


  return login == null ? (
    <Login />
  ) : (
    <>

      {apiloading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <BrandLoader />
        </div>
      ) : (
        <>
          <div className="mainContainer emms-main-container">
            <header className="no-margin">
              <figure className="emms-image-figure">
                <img className="img emm-image" src={image} alt="Logo" />
              </figure>
            </header>

            {SHOW_EMMS_TABLE && (
              <div className="tableAndButtonContainer" >
                <div className="emms-container" style={{ marginLeft: "10%" }}>
                  <EMMS />
                </div>
              </div>
            )}

          </div>
        </>
      )}
    </>
  );
}


export default EmmsDashboard;
